import {Alert} from '@sollapay/ui/components';

import {useDealTypeTranslation} from '@/lib/i18n';
import {getTranslatedErrorMessages} from '@/utils';

import type {TrustPurpose} from '@sollapay/enums';

interface ErrorAlertMessageProps {
  error: unknown;
  className?: string;
  trustPurpose?: TrustPurpose | null;
}

export function ErrorAlertMessage({error, className, trustPurpose}: ErrorAlertMessageProps) {
  const {t} = useDealTypeTranslation('common', trustPurpose ?? null);

  return (
    <Alert
      variant="error"
      title={t('errors.title')}
      description={getTranslatedErrorMessages(error, t)}
      className={className}
    />
  );
}
